import Gateway from 'api/types/Gateway';
import { GatewayResponse } from 'api/types/types';
import { OutletListingItem } from 'redux/slices/profile/types';

export interface GetUserInfoAPIParams {
    authToken: string;
}

export abstract class IOutletGateway extends Gateway {
    abstract getOutletListing(params: GetUserInfoAPIParams): GatewayResponse<OutletListingItem[]>;
}
